module.exports = __webpack_public_path__ + "static/media/5.9bed6b92.JPG";